import React, { useEffect } from 'react';
var PageNav = function (_a) {
    var className = _a.className, isNoBorderTop = _a.isNoBorderTop, children = _a.children, onScroll = _a.onScroll, activeElementId = _a.activeElementId, isWrap = _a.isWrap, navRef = _a.navRef, id = _a.id;
    useEffect(function () {
        var element = document.getElementById('container-nav' + (id ? id : ''));
        if (activeElementId) {
            var activeElement = document.getElementById(activeElementId);
            if (activeElement) {
                activeElement.scrollIntoView();
            }
        }
        var pos = { top: 0, left: 0, x: 0, y: 0 };
        var mouseDownHandler = function (e) {
            element.style.cursor = 'grabbing';
            element.style.userSelect = 'none';
            pos = {
                left: element.scrollLeft,
                top: element.scrollTop,
                x: e.clientX,
                y: e.clientY,
            };
            document.addEventListener('mousemove', mouseMoveHandler);
            document.addEventListener('mouseup', mouseUpHandler);
        };
        var mouseMoveHandler = function (e) {
            var dx = e.clientX - pos.x;
            var dy = e.clientY - pos.y;
            element.scrollTop = pos.top - dy;
            element.scrollLeft = pos.left - dx;
        };
        var mouseUpHandler = function () {
            element.style.cursor = 'grab';
            element.style.removeProperty('user-select');
            document.removeEventListener('mousemove', mouseMoveHandler);
            document.removeEventListener('mouseup', mouseUpHandler);
        };
        element.addEventListener('mousedown', mouseDownHandler);
    }, [activeElementId]);
    return (React.createElement("nav", { ref: navRef, id: 'container-nav' + (id ? id : ''), onScroll: onScroll, className: 'gr-page-nav ' +
            (isWrap ? 'wrap ' : 'no-wrap ') +
            (isNoBorderTop ? 'non-border-top ' : '') +
            ' ' +
            (className ? ' ' + className : '') }, children));
};
export { PageNav };
//# sourceMappingURL=PageNav.js.map